import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { fieldsProps } from './schema';
import Text from '../../fields/Text';
import { useEditMerchant } from '../../../pages/SettingMerchant/hooks';

export default function EditMIDForm({
  handleOpenModal,
  // handleSubmit = () => {},
  // initialValues = {},
  // invalid = true
}) {
  const { midLA } = fieldsProps;
  const { message, loading } = useSelector(
    (state) => state.merchantSetting.edit
  );
  const { handleCancel } = useEditMerchant('formEditMid');

  return (
    <form className={styles.form} encType="multipart/form-data">
      <div>
        {message ? <p className={styles.error}>{message}</p> : null}
        <div className={styles.fields}>
          <Field component={Text} inputProps={midLA} name={midLA.name} />
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          disabled={loading}
          onClick={handleCancel}
          style="default"
          type="button"
        >
          Batalkan
        </Button>
        <Button
          disabled={loading}
          onClick={handleOpenModal}
          type="button"
        >
          Simpan
        </Button>
      </div>
    </form>
  );
}

EditMIDForm.propTypes = {
  handleOpenModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
